import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AuthStore } from '@domains/auth/auth.store';
import { IntercomService } from '@core/services/intercom.service';

// Re-evaluated on every navigation rather than only on login/logout: an expired
// session is redirected to /auth by the auth interceptor without clearing the
// store, and the messenger must never show on a logged-out page. Running on
// route changes also lets Intercom track page views and poll for new messages.
export function provideIntercom(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const router = inject(Router);
      const auth = inject(AuthStore);
      const intercom = inject(IntercomService);

      router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((e) => {
        const user = auth.currentUser();
        if (user && !e.urlAfterRedirects.startsWith('/auth')) {
          intercom.boot(user);
        } else {
          intercom.shutdown();
        }
      });
    }),
  ]);
}
